import request from './request'

export function listMesCompany(data) {
  return request.post('/mes/companies/list', data)
}
export function getMesCompany(id) {
  return request.get('/mes/companies/' + id)
}
export function saveMesCompany(data) {
  return request.post('/mes/companies', data)
}
export function updateMesCompany(data) {
  return request.post('/mes/companies/update', data)
}
export function deleteMesCompany(ids) {
  return request.post('/mes/companies/delete', ids)
}
export function listCompanyAddress(companyId) {
  return request.get('/mes/companies/' + companyId + '/addresses')
}
export function saveCompanyAddress(data) {
  return request.post('/mes/companies/addresses', data)
}
export function updateCompanyAddress(data) {
  return request.post('/mes/companies/addresses/update', data)
}
export function deleteCompanyAddress(ids) {
  return request.post('/mes/companies/addresses/delete', ids)
}
export function listCompanyContact(companyId) {
  return request.get('/mes/companies/' + companyId + '/contacts')
}
export function saveCompanyContact(data) {
  return request.post('/mes/companies/contacts', data)
}
export function updateCompanyContact(data) {
  return request.post('/mes/companies/contacts/update', data)
}
export function deleteCompanyContact(ids) {
  return request.post('/mes/companies/contacts/delete', ids)
}
